import { render, staticRenderFns } from "./book-vehicle.vue?vue&type=template&id=74819f58&"
import script from "./book-vehicle.vue?vue&type=script&lang=js&"
export * from "./book-vehicle.vue?vue&type=script&lang=js&"
import style0 from "./book-vehicle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports